<div *ngIf="!loader" style="position: relative;">

    <owl-carousel-o [options]="customOptions" #carousel>

        <ng-template carouselSlide *ngFor="let img of gallery">
            <div class="pos-img-cont" [ngStyle]="{'width': '100%', 'height': width, 'background-image': 'url(' +  img.image + ')'}"></div>
        </ng-template>

    </owl-carousel-o>

    <button mat-mini-fab class="arrow left clicked whited" (click)="prevImageClick()" *ngIf="gallery.length > 1">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>

    <button mat-mini-fab class="arrow right clicked whited" (click)="nextImageClick()" *ngIf="gallery.length > 1">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>

</div>


<div *ngIf="loader" fxLayoutAlign="center center" [ngStyle]="{'width' : '100%', 'height' : width}">
    <span class="mat-caption">{{"loadingImages"|translate}}</span>
</div>